import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { t } from '@nextcloud/l10n'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import NcNoteCard from '@nextcloud/vue/components/NcNoteCard'
import IconNetworkStrength2Alert from 'vue-material-design-icons/NetworkStrength2Alert.vue'
import { useGetToken } from '../../composables/useGetToken.ts'
import { useIsInCall } from '../../composables/useIsInCall.js'
import { CONVERSATION } from '../../constants.ts'
import { EventBus } from '../../services/EventBus.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'InternalSignalingHint',
  setup(__props) {

const store = useStore()
const isInCall = useIsInCall()
const token = useGetToken()

const isGroupConversation = computed(() => {
	return [CONVERSATION.TYPE.GROUP, CONVERSATION.TYPE.PUBLIC].includes(store.getters.conversation(token.value)?.type)
})
const show = ref(false)

const warningDescription = t('spreed', 'Calls without High-performance backend can cause connectivity issues and high load on devices. {linkstart}Learn more{linkend}')
	.replace('{linkstart}', '<a target="_blank" rel="noreferrer nofollow" class="external" href="https://portal.nextcloud.com/article/Nextcloud-Talk/High-Performance-Backend/Installation-of-Nextcloud-Talk-High-Performance-Backend">')
	.replace('{linkend}', ' ↗</a>')

const warningTitle = t('spreed', 'Talk setup incomplete')

onMounted(() => {
	EventBus.on('signaling-internal-show-warning', showInternalWarning)
})

onBeforeUnmount(() => {
	EventBus.on('signaling-internal-show-warning', showInternalWarning)
})

watch(isInCall, (value) => {
	if (!value) {
		show.value = false
	}
})

/**
 *
 */
function showInternalWarning() {
	if (isGroupConversation.value) {
		show.value = true
	}
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(_unref(NcNoteCard), {
    type: "warning",
    class: "internal-warning"
  }, {
    icon: _withCtx(() => [
      _createVNode(IconNetworkStrength2Alert, {
        "fill-color": "var(--color-warning-text)",
        size: 20
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("strong", null, _toDisplayString(_unref(warningTitle)), 1),
      _createElementVNode("p", { innerHTML: _unref(warningDescription) }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 512)), [
    [_vShow, show.value]
  ])
}
}

})